import React, { useState, useEffect, useRef } from "react";
import Select from "../../ui/PortalSelect";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import "antd/dist/antd.css";
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../backend_url';
import { formatDate, formatDate_withTime } from '../commonFunctions';
import { Country } from "country-state-city";
import { saveAs } from 'file-saver'
import DownloadIcon from '@mui/icons-material/Download';
import Button from '@mui/material/Button';
import {
  deriveVendorAccountSelection,
  loadAccessibleCompanies,
  readSessionUser,
} from '../accountAccess';
import { expectExactPayload, requestErrorMessage } from '../mutationContract';
import {
  PORTAL_IMAGE_ACCEPT,
  portalImageValidationError,
} from '../portalImageUpload';

export default function UpdateForm() {

  var obj_company_detail = "";

  const [companyDetail, setcompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [updateFlag, setUpdateFlag] = useState(false);
  const [updateErrorCodesDetails, setUpdateErrorCodesDetails] = useState([]);
  const [lgShow1, setLgShow1] = useState(false);
  const [lgShow2, setLgShow2] = useState(false);
  const [updateClicked, setUpdateClicked] = useState(false);
  const [codeDescription, setCodeDescription] = useState("");
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [errorCodeDetails, setErrorCodeDetails] = useState([]);
  const [receiveMail, setReceiveMail] = useState(false);
  const [country, setCountry] = useState("");
  const [SIPPDetail, setSIPPDetail] = useState([]);
  const [SIPPName, setSIPPName] = useState("");
  const [carClassImage, setCarClassImage] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [carsDetail, setCarsDetail] = useState([]);
  const [savingImage, setSavingImage] = useState(false);
  const [accountSelectorDisabled, setAccountSelectorDisabled] = useState(false);

  //This is for scrolling
  const titleRef = useRef()

  function handleBackClick() {
    titleRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  //API call
  useEffect(() => {
    let active = true;
    const { user: foundUser } = readSessionUser();
    if (!foundUser) {
      setcompanyDetail([]);
      return undefined;
    }

    setLoggedInUserDetail(foundUser)

    loadAccessibleCompanies(
      baseURL,
      foundUser,
      'OptionalServicesImages_Account Access'
    )
      .then((accounts) => {
        if (!active) return;
        const selection = deriveVendorAccountSelection(accounts, foundUser);
        setcompanyDetail(selection.accounts);
        setAccountSelectorDisabled(selection.isSelectorDisabled);
        if (selection.shouldAutoSelect) {
          setCompanyName(selection.selectedAccountName);
        }
      })
      .catch(() => {
        if (active) {
          setcompanyDetail([]);
          setAccountSelectorDisabled(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  //Trigger on Company Name Dropdown Changes , getting Company ID
  useEffect(() => {

    if (companyDetail && companyName) {

      setSIPPDetail([]);
      setImageURL(null)

      obj_company_detail = companyDetail.filter(
        (value) => value.company_name === companyName
      )[0];
      const company_id_temp = obj_company_detail._id;

      axios.get(
        baseURL + "/get_optional_services_standard/" + company_id_temp
        + "?companyNumber=" + encodeURIComponent(company_id_temp.toString())
      )
        .then((res) => {

          let arr1 = res.data
          let car_class_arr = []
          let arr2 = [];

          for(let t=0; t<arr1.length; t++){
            if(car_class_arr.indexOf(arr1[t].extraCategory) < 0){

              arr2.push(arr1[t]);
              car_class_arr.push(arr1[t].extraCategory);
            }
          }

          setSIPPDetail(arr2);
          setcompany_id(company_id_temp);
          setUpdateFlag(!updateFlag);
          setLgShow1(false);
        });

    }//if condition ends

  }, [companyName]);

  //Option for company name
  const companyNameOptions = companyDetail.map((value) => (

    { value: value.company_name, label: value.company_name }
  ));
  //Option for SIPP
  const SIPPOptions = SIPPDetail.map((value) => (

    { value: value.extraCategory, label: value.extraCategory }
  ));

  const handleInputChangeCompanyName = characterEntered => {
    setCompanyName(characterEntered.value);
  };
  const handleInputChangeSIPP = characterEntered => {
    setSIPPName(characterEntered.value);
  };


  useEffect(() => {

    if (country && company_id) {

      axios.get(
        baseURL + "/get_optional_services_images/" + encodeURIComponent(country.name)
        + "?companyNumber=" + encodeURIComponent(company_id.toString())
      )
        .then((res) => {

          setCarsDetail(res.data)

        }).catch((e) => { });
    }

  }, [updateFlag])

  //handle Fetch Click
  const handleFetch = (e) => {

    e.preventDefault();
    setLgShow1(true);

    if (country && company_id) {

      axios.get(
        baseURL + "/get_optional_services_images/" + encodeURIComponent(country.name)
        + "?companyNumber=" + encodeURIComponent(company_id.toString())
      )
        .then((res) => {

          setCarsDetail(res.data)

        }).catch((e) => { });
    }
  }



  useEffect(() => {

    if (lgShow1 === false) {
      setUpdateClicked(false);
    }

  }, [lgShow1])


  const handleSubmit = (e) => {

    e.preventDefault();

    if (companyName === "") {
      Swal.fire("Account field can't be empty");
      return;
    }

    else if (country === "") {
      Swal.fire("Country field can't be empty");
      return;
    }

    else if (SIPPName === "") {
      Swal.fire("Optional Services Standard field can't be empty");
      return;
    }

    else if (carClassImage === null || carClassImage === '') {
      Swal.fire("Please choose an image");
      return;
    }


    Swal.fire({
      title: 'Do you want to save this image ?',

      showCancelButton: true,
      confirmButtonText: 'Yes',

    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        // const arr_json_mapping = {
        //   "_id": company_id + "-" + country.name + "-" + SIPPName,
        //   "account_id": company_id.toString(),
        //   "country": country.name,
        //   "SIPP_code": SIPPName,
        //   "created_date": new Date(),
        //   "updated_date": new Date(),
        //   "created_by": loggedInUserDetail.userEmail,
        //   "updated_by": loggedInUserDetail.userEmail,
        //   "file": carClassImage
        // }

        let formData = new FormData();
        // console.log("carClassImage1");
        // console.log(carClassImage)
        // let car_detail = {...carClassImage}
        // console.log("carClassImage2");
        // console.log(car_detail)
        // car_detail['name'] = "TIGER_SINGH.png" 
        // console.log("carClassImage3");
        // console.log(car_detail)

        formData.append("file", carClassImage);
        formData.append("companyNumber", company_id.toString());
        formData.append("_id", company_id + "-" + country.name + "-" + SIPPName);
        formData.append("account_id", company_id.toString());
        formData.append("country", country.name);
        formData.append("SIPP_code", SIPPName);
        formData.append("created_date", new Date());
        formData.append("updated_date", new Date());
        formData.append("created_by", loggedInUserDetail.userEmail);
        formData.append("updated_by", loggedInUserDetail.userEmail);

        setSavingImage(true);
        axios.post(
          baseURL + "/save_optional_services_images?companyNumber="
          + encodeURIComponent(company_id.toString()),
          formData
        )
          .then((res) => {
            expectExactPayload(res.data, 'success', 'Optional Services image save');

            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Saved Successfully',
              showConfirmButton: false,
              timer: 3000
            })

            setUpdateFlag(!updateFlag)
            setCarClassImage(null);
            setSIPPName("");
            setImageURL(null);
          })
          .catch((error) => {
            console.error('Unable to save Optional Services image:', error)
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Save failed',
              text: requestErrorMessage(
                error,
                'Unable to save the Optional Services image. Please try again.'
              )
            })
          })
          .finally(() => setSavingImage(false));
      } else {
        Swal.fire('Changes are not saved');
      }
    });


  }//handlesubmit ends here


  const handleUpdate = (e) => {

    e.preventDefault();

    if (companyName === "") {
      Swal.fire("Account field can't be empty");
      return;
    }

    else if (country === "") {
      Swal.fire("Country field can't be empty");
      return;
    }

    else if (SIPPName === "") {
      Swal.fire("Car Class field can't be empty");
      return;
    }

    else if (carClassImage === null || carClassImage === '') {
      Swal.fire("Please choose an image");
      return;
    }


    Swal.fire({
      title: 'Do you want to save this image ?',

      showCancelButton: true,
      confirmButtonText: 'Yes',

    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        let formData = new FormData();

        formData.append("file", carClassImage);
        formData.append("companyNumber", company_id.toString());
        formData.append("_id", company_id + "-" + country.name + "-" + SIPPName);
        formData.append("account_id", company_id.toString());
        formData.append("country", country.name);
        formData.append("SIPP_code", SIPPName);
        formData.append("created_date", new Date());
        formData.append("updated_date", new Date());
        formData.append("created_by", loggedInUserDetail.userEmail);
        formData.append("updated_by", loggedInUserDetail.userEmail);

        setSavingImage(true);
        axios.post(
          baseURL + "/save_optional_services_images?companyNumber="
          + encodeURIComponent(company_id.toString()),
          formData
        )
          .then((res) => {
            expectExactPayload(res.data, 'success', 'Optional Services image update');

            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Updated Successfully',
              showConfirmButton: false,
              timer: 3000
            })

            setUpdateFlag(!updateFlag)
            setCarClassImage(null);
            setSIPPName("");
            setImageURL(null);
            setUpdateClicked(false);

          })
          .catch((error) => {
            console.error('Unable to update Optional Services image:', error)
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Update failed',
              text: requestErrorMessage(
                error,
                'Unable to update the Optional Services image. Please try again.'
              )
            })
          })
          .finally(() => setSavingImage(false));
      } else {
        Swal.fire('Changes are not saved');
      }
    });


  }//update rate rules ends

  const updateCars = (val) => {

    Swal.fire({
      title: 'Do you want to edit this ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {



      if (result.isConfirmed) {

        setSIPPName(val.SIPP_code);
        setLgShow1(true);
        setLgShow2(true);
        setUpdateClicked(true);
        setImageURL(baseURL + "/static/img/" + val.image_path);

        handleBackClick();

      }
    })
  }

  const handleImageChange = (e) => {
    const selectedImage = e.target.files?.[0];
    const validationError = portalImageValidationError(selectedImage);
    if (validationError) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Invalid image',
        text: validationError,
      });
      e.target.value = '';
      return;
    }

    setCarClassImage(selectedImage);
    setImageURL(URL.createObjectURL(selectedImage))
  }

  const downloadImage = (image_url, image) => {
    saveAs(image_url, image) // Put your image url here.
  }

  const handleCancel = (e) => {

    e.preventDefault();
    setSIPPName("");
    setLgShow1(true);
    setLgShow2(true);
    setUpdateClicked(false);
    setImageURL("");

  }

  return (
    <>
      <div className="row pt-2" ref={titleRef} id="title">
        <div className="col-8 mx-3">
          <span style={{ color: '#1E1E1E', fontSize: '21px' }}>Select account to proceed ahead : </span>
        </div>
      </div>

      <div className="row pt-5">
        {/* <div className="col-1"></div> */}
        <div className="col-10 mx-3">
          {/* First Row */}
          <div className="row">
            <div className="col-md-2 mb-3">
              <label htmlFor="company_name" className="form-label">
                Account Name
              </label>
            </div>

            <div className="col-md-4 mb-3">

              <Select

                value={{ value: companyName, label: (companyName ? companyName : "Select Account Name") }}
                inputId="company_name"
                name="company_name"
                options={companyNameOptions}
                onChange={handleInputChangeCompanyName}
                isDisabled={accountSelectorDisabled}

              />

            </div>


            <div className="col-md-1 mb-3"></div>

            <div className="col-md-2 mb-3">
              {/* <label htmlFor="company_id" className="form-label">
                Account ID
              </label> */}
            </div>
            <div className="col-md-2 mb-3">
              {/* <input
                type="text"
                className="form-control"
                value={company_id}
                id="company_id"
                disabled
              /> */}
            </div>

          </div>{/* first row wrapper ends */}

          {/* Second Row */}
          <div className="row">
            <div className="col-md-2 mb-3">
              <label htmlFor="company_name" className="form-label">
                Select Country
              </label>
            </div>

            <div className="col-md-4 mb-3">

              <Select
                placeholder={"Select Country"}
                options={Country.getAllCountries()}
                value={country}
                getOptionLabel={(options) => options.name}
                getOptionValue={(options) => options.name}
                onChange={(e) => {
                  setCountry(e);
                  // handleCountry(e);
                }}
              />
            </div>


            <div className="col-md-1 mb-3"></div>

            <div className="col-md-2 mb-3">
              {/* <label htmlFor="company_id" className="form-label">
                Account ID
              </label> */}
            </div>
            <div className="col-md-2 mb-3">
              {/* <input
                type="text"
                className="form-control"
                value={company_id}
                id="company_id"
                disabled
              /> */}
            </div>

          </div>{/* Second row wrapper ends */}

          {/* Third Row */}
          <div className="row mt-3">

            <div className="col-md-2 mb-3">

            </div>
            <div className="col-md-4 mb-3 d-flex justify-content-end">
              <button type="submit" className="btn btn-primary" onClick={(e) => handleFetch(e)}>
                {"Fetch"}
              </button>

            </div>

            <div className="col-md-12 mb-2 d-flex justify-content-start">
              {companyName === '' && lgShow1 ? (<span style={{ color: 'red' }}>Please select Account Name to proceed ahead</span>) : ""}
            </div>

            {
              companyName && lgShow1 ? (
                <div className="col-md-12 mb-5 d-flex justify-content-start">
                  <button type="submit" className="btn btn-primary" onClick={() => setLgShow2(!lgShow2)}>
                    {!lgShow2 ? "+ Add New" : "- Hide"}
                  </button>

                </div>
              ) : ""
            }


            {
              companyName && lgShow1 && lgShow2 ? (
                <>
                  {/* fourth row wrapper ends */}
                  <div className="row">
                    <div className="col-md-2 mb-3">
                      <label htmlFor="car_class" className="form-label">
                      Optional Services Standard
                      </label>
                    </div>

                    <div className="col-md-4 mb-3">

                      <Select

                        value={{ value: SIPPName, label: (SIPPName ? SIPPName : "Select Optional Services Standard") }}
                        inputId="car_class"
                        name="car_class"
                        options={SIPPOptions}
                        onChange={handleInputChangeSIPP}

                      />

                    </div>


                    <div className="col-md-2 mb-3"></div>

                    {/* <div className="col-md-2 mb-3">
                      <label htmlFor="image" className="form-label">
                        Upload Image
                      </label>
                    </div> */}
                    <div className="col-md-3 mb-3">
                      <Button variant="contained" component="label" disabled={savingImage}>
                        {savingImage ? 'Saving...' : 'Choose Image...'}
                        <input hidden accept={PORTAL_IMAGE_ACCEPT} type="file" disabled={savingImage} onChange={(e) => handleImageChange(e)}/>
                      </Button>
                      {/* <input
                        type="file"
                        className="form-control"
                        onChange={(e) => handleImageChange(e)}
                        id="image"
                      /> */}
                    </div>

                  </div>{/* fourth row wrapper ends */}

                  {/* fifth row wrapper ends */}
                  {imageURL && (
                    <div className="row">
                      <div className="col-md-2 mb-3">

                      </div>

                      <div className="col-md-4 mb-3">

                      </div>


                      <div className="col-md-1 mb-3"></div>

                      <div className="col-md-1 mb-3">

                        {/* <label htmlFor="image" className="form-label">
                          Selected Image
                        </label> */}
                      </div>
                      <div className="col-md-3 mb-3">
                        <img src={imageURL} style={{ maxWidth: '60%' }} />
                      </div>

                    </div>
                  )}
                  {/* fifth row wrapper ends */}


                  <div className="col-md-11 mt-4 d-flex justify-content-end">
                    {
                      !updateClicked ? <button type="submit" className="btn btn-success" disabled={savingImage} onClick={handleSubmit}>
                        {savingImage ? 'Saving...' : 'Save'}
                      </button>
                        :

                        <>
                          <div className="col-md-8 d-flex justify-content-end">
                            <button type="submit" className="btn btn-danger" disabled={savingImage} onClick={handleCancel}>
                              Cancel
                            </button>
                          </div>
                          <div className="col-md-3 d-flex justify-content-end">
                            <button type="submit" className="btn btn-success" disabled={savingImage} onClick={handleUpdate}>
                              {savingImage ? 'Updating...' : 'Update'}
                            </button>
                          </div>

                        </>


                    }

                  </div>

                </>
              ) : ""
            }


          </div>{/* Third row wrapper ends */}

          {/* Fourth Row*/}
          {lgShow1 && <>
            <div className="row mt-3">
              <div className="col-12">
                <h5 className="mb-3">Existing Optional Services Images: </h5>
                <div
                  className="mvp-table-scroll mvp-table-scroll--wide"
                  role="region"
                  aria-label="Existing optional services images"
                  tabIndex="0"
                >
                <table className="table" >
                  <thead>
                    <tr>
                      <th scope="col">Optional Services Standard Image</th>
                      <th scope="col">Optional Services Standard</th>
                      <th scope="col">Account</th>
                      <th scope="col">Country</th>
                      <th scope="col">Updated On</th>
                      <th scope="col">Updated By</th>
                      <th scope="col">Edit</th>
                      <th scope="col">Download Image</th>
                    </tr>
                  </thead>
                  <tbody>

                    {
                      carsDetail.length > 0 ? carsDetail.map((val, i) => (
                        <tr>
                          <td style={{ width: "200px" }}><img src={baseURL + "/static/img/" + val.image_path} alt={`${val.SIPP_code || 'Optional service'} preview`} style={{ maxWidth: '60%', minWidth: '40%' }} /></td>
                          <td>{val.SIPP_code}</td>
                          <td>{companyName}</td>
                          <td>{val.country}</td>
                          <td>{formatDate_withTime(new Date(val.updated_date))}</td>
                          <td>{val.updated_by}</td>
                          <td><button type="button" className="mvp-table-icon-action" aria-label={`Edit ${val.SIPP_code || 'optional service'} image`} onClick={() => { updateCars(val); }}><EditIcon /></button></td>
                          <td align="center"><button type="button" className="mvp-table-icon-action" aria-label={`Download ${val.SIPP_code || 'optional service'} image`} onClick={() => { downloadImage(baseURL + "/static/img/" + val.image_path, val.image_path); }}><DownloadIcon /></button></td>

                        </tr>

                      )) : <tr><td colSpan={8} className="text-center text-danger"><strong>No Optional Services Images for selected Account and Country</strong></td></tr>
                    }

                  </tbody>
                </table>
                </div>
              </div>
            </div>{/* Fourth row ends */}
          </>
          }
          <div className="col-md-10 mb-4 ">

          </div>

        </div>


      </div> {/* overall wrapper row ends */}

    </>
  );
}
